"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { integrations } from "./crm.data";

/* .shdo */
const SOFT_SHADOW = "shadow-[0_3.4px_2.7px_-30px_rgba(0,0,0,0.06),0_8.2px_8.9px_-30px_rgba(0,0,0,0.07),0_25px_40px_-30px_rgba(0,0,0,0.2)]";

/* .up-hor / .bd-hor easing */
const EASE = "ease-[cubic-bezier(0.17,0.85,0.438,0.99)] duration-[1200ms]";
export default function FeaturesGrid() {
  const $ = _c(22);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease: [0.17, 0.85, 0.438, 0.99]
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="mb-[20px] font-poppins text-[26px] font-semibold leading-[36px] text-[#050748] sm:text-[32px] sm:leading-[44px] lg:text-[40px] lg:leading-[52px] dark:text-white">Easy Third-Party Integrations for Better Healthcare Services</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="m-0 font-open-sans text-[15px] leading-[26px] text-[#6a6a8e] sm:text-[17px] sm:leading-[28px] dark:text-slate-300">Connect with payment systems, telemedicine, and medical records easily. Our doctor booking app works with trusted services to make healthcare management simple and efficient.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <div className="mx-auto mb-[54px] max-w-[900px] text-center">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== desktopAnimations) {
    t8 = integrations.map((item, idx) => {
      const isRaised = idx % 3 === 1;
      return <motion.div key={item.title} initial={desktopAnimations ? {
        opacity: 0,
        y: 40
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        delay: idx % 3 * 0.2,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="h-full"><div className={`group relative h-full overflow-hidden rounded-lg border border-gray-100 bg-white px-5 py-[50px] transition-transform ${EASE} ${SOFT_SHADOW} hover:-translate-y-[7.5px] dark:border-white/5 dark:!bg-white/[0.03] ${isRaised ? "lg:-mt-[30px]" : ""}`}><div className="mb-5 w-[79px]"><Image src={item.image} alt={item.alt || item.title} width={79} height={79} className="h-auto w-4/5 object-contain" /></div><h3 className="m-0 mb-3 text-left font-poppins text-[19px] font-semibold leading-[28px] text-[#050748] sm:text-[22px] sm:leading-[32px] dark:text-white">{item.title}</h3><p className="m-0 text-left font-open-sans text-[15px] leading-[26px] text-[#6a6a8e] sm:text-[17px] sm:leading-[28px] dark:text-slate-400">{item.description}</p><span aria-hidden={true} className={`absolute bottom-0 left-0 h-1 w-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-[width] ${EASE} group-hover:w-full`} /></div></motion.div>;
    });
    $[15] = desktopAnimations;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <div className="grid grid-cols-1 gap-[30px] sm:grid-cols-2 lg:grid-cols-3">{t8}</div>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <section className="w-full bg-gradient-to-b from-[#DBF2FF] from-[10%] to-[#FFFFFF] py-14 font-sans sm:py-20 lg:py-24 dark:from-gray-950 dark:to-gray-900"><div className="mx-auto w-full max-w-[1200px] px-5 sm:px-8">{t7}{t9}</div></section>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}